var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEllipsis = function SvgEllipsis(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    "aria-label": "ellipsis",
    className: "ellipsis_svg__svg-icon ellipsis_svg__ellipsisIcon",
    "data-view-component": "true",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEllipsis);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsPSJlbGxpcHNpcyIgcm9sZT0iaW1nIiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgd2lkdGg9IjE2IgogIGRhdGEtdmlldy1jb21wb25lbnQ9InRydWUiIGNsYXNzPSJzdmctaWNvbiBlbGxpcHNpc0ljb24iPgogIDxwYXRoCiAgICBkPSJNOCA5YTEuNSAxLjUgMCAxMDAtMyAxLjUgMS41IDAgMDAwIDN6TTEuNSA5YTEuNSAxLjUgMCAxMDAtMyAxLjUgMS41IDAgMDAwIDN6bTEzIDBhMS41IDEuNSAwIDEwMC0zIDEuNSAxLjUgMCAwMDAgM3oiPgogIDwvcGF0aD4KPC9zdmc+Cg==";